document.addEventListener('DOMContentLoaded', function() {
    const lightbox = GLightbox({
        'title': false,
    });

    initBlobsAnimation();
    toggleActiveFilter();

    // scroll to section
    let ctasHero = document.querySelectorAll('.hero .btn');
    ctasHero.forEach(cta => {
        cta.addEventListener('click', (e) => {
            e.preventDefault();
            scrollTo('.products');
        })
    })

    // swipers 
    const swiperHero = new Swiper('.swiper-hero', {
        slidesPerView: 1,
        speed: 1000,
        loop: true,

        pagination: {
            el: '.hero .swiper-pagination',
            clickable: true,
        }
    })
    const swiperProcess = new Swiper('.swiper-process', {
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        spaceBetween: 20,
        
        navigation: {
            prevEl: '.process .arrow-left',
            nextEl: '.process .arrow-right',
        },
        breakpoints: {
            992: {
                slidesPerView: 2,
            }
        }
    })
    let swiperProducts = new Swiper('.swiper-products', {
        speed: 1000,
        spaceBetween: 32,
        
        navigation: {
            prevEl: '.products .arrow-left',
            nextEl: '.products .arrow-right',
        },
        breakpoints: {
            0: {
                enabled: false,
            },
            992: {
                enabled: true,
                slidesPerView: 3,
            }
        }
    })
    let swiperTestimonials = new Swiper('.swiper-testi', {
        slidesPerView: 1,
        speed: 1000,
        loop: true,
        spaceBetween: 32,
        autoHeight: true,
        // effect: "fade",
        
        autoplay: {
            delay: 6000,
            disableOnInteraction: true,
        },
        navigation: {
            prevEl: '.testimonials .arrow-left',
            nextEl: '.testimonials .arrow-right',
        },
    })
    let swiperInsta = new Swiper('.swiper-insta', {
        slidesPerView: 1.2,
        speed: 1000,
        loop: true,
        spaceBetween: 0,
        centeredSlides: true,
        
        navigation: {
            prevEl: '.products .arrow-left',
            nextEl: '.products .arrow-right',
        },
        breakpoints: {
            992: {
                slidesPerView: 4,
                loop: false,
                centeredSlides: false,
            }
        }
    })

    const productTypes = document.querySelectorAll('#productsFilters li');
    const productCategories = document.querySelectorAll('.swiper-slide[data-type]');
    productTypes.forEach(productType => {
        productType.addEventListener('click', function(li) {
            swiperProducts.destroy(true, true);
            let typeId = this.getAttribute('data-type');
            // console.log('TypeId ' + typeId);
            
            productCategories.forEach(category => {
                let categoryType = category.getAttribute('data-type');
                if (categoryType == typeId || typeId == 0) {
                    category.classList.remove('d-none');
                } else {
                    category.classList.add('d-none');
                }
            });
            swiperProducts = new Swiper('.swiper-products', {
                slidesPerView: 1,
                speed: 1000,
                loop: true,
                spaceBetween: 32,
                navigation: {
                    prevEl: '.products .arrow-left',
                    nextEl: '.products .arrow-right',
                },
                breakpoints: {
                    992: { slidesPerView: 3 }
                }
            });
        });
    });
})

// functions
function initBlobsAnimation() {
    let blobs = document.querySelectorAll('.hero .blob');

    blobs.forEach((blob, i) => {
        setTimeout(() => {
            blob.classList.add('floating');
        }, i * 500);
    });
}

function toggleActiveFilter() {
    let filters = document.querySelectorAll('#productsFilters button');
    
    filters.forEach(filter => {
        filter.addEventListener('click', function() {
            filters.forEach(f => f.classList.remove('active'))

            this.classList.add('active')
        })
    })
}

function scrollTo(section) {
    let sectionEl = document.querySelector(section);

    if (sectionEl) {
        if ( window.innerWidth > 992 ) {
            // lenis scroll
            window.lenis.scrollTo(sectionEl, {
                duration: 1.2,
                easing: (t) => t * (2 - t),
            });
        } else {
            // scroll nativo
            sectionEl.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }
}